export const BackendServerURL = "https://desolate-journey-26519.herokuapp.com"
export const StarterPrice = {
    priceId:"price_1IVxksJ4gYClsoqIe1c6C2Tb",
    id: "prod_J8EDfcWxMSueTz",
}
export const PlusPrice = {
    priceId:"price_1IX445J4gYClsoqISqrZaKkR",
    id: "prod_J9MnmvhFjIWKmB",
}
export const ProPrice = {
    priceId:"price_1KQv2BJ4gYClsoqIEul51MkQ",
    id: "prod_L79K5FdpSbfp39",
}
export const getNameByProdId = (id) => {
    switch(id) {
        case StarterPrice.id:
            return "starter"
        case PlusPrice.id:
            return "plus"
        case ProPrice.id:
            return "pro"
        default:
            return "Unknown"
    }
}